<template>
    <base-page :title="$t('l.fault_list')" icon="md-alert">
        <Row slot="extra" type="flex" justify="end">
            <Col>
                <DatePicker style="margin-left: 5px" v-show="table.search.solved" v-model="table.search.month" type="month" :placeholder="$t('l.fault_month')" @on-change="searchSolvedList"></DatePicker>
            </Col>

            <Col v-show="table.search.solved" class="margin-left-5">
                <Button @click="exportFaultRecord" type="primary">{{$t('l.export_fault_record')}}</Button>
            </Col>
            <Col class="margin-left-5">
                <RadioGroup  v-model="table.search.solved" type="button" @on-change="searchSolvedList">
                    <Radio :label="0" style="height: 26px;line-height: 24px;font-size: 14px" >{{$t('l.untreated')}}</Radio>
                    <Radio :label="1" style="height: 26px;line-height: 24px;font-size: 14px" >{{$t('l.processed')}}</Radio>
                </RadioGroup>
            </Col>
            <Col class="margin-left-5">
                <Button @click="loadData(table.page.current)">{{$t('l.fresh')}}</Button>
            </Col>
            <Col class="margin-left-5">
                <Input class="search-keyword" v-model="table.page.keyword" search
                       suffix="ios-search" :placeholder="$t('l.remark67')"
                       @on-change="searchBlur" @on-search="loadData(table.page.current)"/>
            </Col>
        </Row>
        <template>
            <Row class="full">
                <Table stripe border :columns="getColumns" :data="table.data" :loading="table.loading"></Table>
                <Row type="flex" justify="center">
                    <Col>
                        <Page size="small"
                              :current="table.page.current"
                              :page-size="table.page.size"
                              :total="table.page.total"
                              show-elevator show-sizer
                              show-total
                              @on-page-size-change="($event)=>{table.page.size = $event,loadData(1)}"
                              @on-change="loadData"></Page>
                    </Col>
                </Row>
            </Row>
        </template>
        <lg-modal :cancel-text="$t('l.cancel')" :confirm-text="$t('l.close')" :show-cancel="false" :title="$t('l.fault')" :show="modal.showFault" :loading="modal.loading" @on-submit="modal.loading=false; modal.showFault=false;"
                  @on-cancel="modal.loading=false; modal.showFault=false;">
            <Tabs v-model="modal.tabName">
                <TabPane :label="$t('l.fault_des')" name="1">
                    <Form  v-if="modal.fault" :model="modal.fault" :label-width="80">
                        <FormItem :label-width="100" :label="$t('l.fault_code')">
                            <Input  v-model="modal.fault.fault_no" :readonly="true"/>
                        </FormItem>
                      <FormItem :label-width="100" :label="$t('l.gb_fault_no')">
                        <Input v-model="modal.fault.gb_fault_no" :readonly="true"/>
                      </FormItem>
                        <FormItem  :label-width="100":label="$t('l.fault_name')">
                            <Input v-model="modal.fault.fault_name" :readonly="true"/>
                        </FormItem>
                        <FormItem :label-width="100" :label="$t('l.fault_des')">
                            <Input type="textarea" v-model="modal.fault.fault_explain" :readonly="true"/>
                        </FormItem>
                        <FormItem :label-width="100" :label="$t('l.fault_solution')">
                            <Input type="textarea" v-model="modal.fault.fault_solution" :readonly="true"/>
                        </FormItem>
                        <FormItem :label-width="100" :label="$t('l.resume_condition')">
                            <Input type="textarea" v-model="modal.fault.fault_resume_condition" :readonly="true"/>
                        </FormItem>
                    </Form>
                </TabPane>
                <TabPane :label="$t('l.fault_state')" name="2">
                    <div style="max-height: 350px; overflow-y: auto">
                        <fault-detail :params="modal.params"></fault-detail>
                    </div>
                </TabPane>
                <TabPane v-if="!!modal.device.id" :label="$t('l.device_info')" name="3">
                    <div style="max-height: 350px; overflow-y: auto">
                        <CellGroup>
                            <Cell :title="$t('l.elevator_name')" :label="modal.device.name" />
                            <template v-if="modal.device.j_mt_workers">
                                <Cell v-for="(worker, index_wkr) in modal.device.j_mt_workers" :key="worker.id" :title="$t('l.mt_person')+(modal.device.j_mt_workers.length>1?(index_wkr+1):'')" :label="worker.realname" :extra="worker.mobile"/>
                            </template>
                            <Cell v-if="modal.device.mt_company" :title="$t('l.mt_company')" :label="modal.device.mt_company.name" />
                            <Cell v-if="modal.device.j_region" :title="$t('l.region')" :label="modal.device.j_region.province.name+modal.device.j_region.city.name+modal.device.j_region.area.name" />
                            <Cell v-if="modal.device.community_name" :title="$t('l.install_location')" :label="modal.device.community_name+modal.device.j_location.building.name+modal.device.j_location.unit.name" />
                            <Cell v-if="modal.device.factory" :title="$t('l.manufacturer')" :label="modal.device.factory.name" />
                            <Cell :title="$t('l.device_id')" :label="modal.device.id+''" />
                            <Cell :title="$t('l.terminal_number')" :label="modal.device.terminal_id"></Cell>
                            <Cell v-if="modal.device.j_alarm_charger" :title="$t('l.alerter')" />
                            <ul class="alarm_charger">
                                <template v-if="modal.device.j_alarm_charger&&modal.device.j_alarm_charger.length">
                                    <li v-for="(alarm,index) in modal.device.j_alarm_charger" :key="index">
                                        <span>{{alarm.name}}: {{alarm.mobile}}</span>
                                    </li>
                                </template>
                            </ul>
                        </CellGroup>
                    </div>
                </TabPane>
            </Tabs>
        </lg-modal>
    </base-page>
</template>

<script>
    import BasePage from "../my-components/base-page";
    import util from '@/libs/util';
    import axios from 'axios';
    import LgModal from "../my-components/lg-modal";
    import  JsonFieldAdapter from "../device/modules/json-field-adapter"
    import faultDetail from "./component/fault-detail"


    export default {
        name: 'page-fault',
        components: {LgModal, BasePage,faultDetail},
        data() {
            return {
                table: {
                    search: {
                        solved: 0,
                        month: new Date(),
                        content:""
                    },
                    loading: false,
                    selected: [],
                    columns: [],
                    data: [],
                    page: {
                        current: 1,
                        size: 10,
                        total: 0,
                        sortKey: 'occur_time',
                        sortMethod: 'desc',
                        keyword:''
                    }
                },
                modal: {
                    showFault: false,
                    title: this.$t('l.fault'),
                    loading: false,
                    currentIndex: -1,
                    tabName: '1',
                    fault: {
                        fault_no: '',
                        fault_name: '',
                        fault_explain: '',
                        fault_solution: '',
                        fault_resume_condition: ''
                    },
                    params: {},
                    device: {}
                },
            };
        },
        computed: {
            getColumns(){
                return [
                    {
                        title: 'ID',
                        align: 'center',
                        width: 100,
                        key: 'fault_id'
                    },
                    {
                        title: this.$t('l.lift'),
                        align:'center',
                        key: 'device_name'
                    },
                    {
                        title: this.$t('l.lift_device'),
                        align:'center',
                        key: 'model'
                    },
                    {
                        title: this.$t('l.fault_code'),
                        align: 'center',
                        width:100,
                        key: 'fault_no',
                    },
                  {
                    title: this.$t('l.gb_fault_no'),
                    align: 'center',
                    width:120,
                    key: 'gb_fault_no',
                  },
                    {
                        title: this.$t('l.fault_name'),
                        align: 'left',
                        key: 'fault_record',
                        render: (h, params) => {
                            let record = util.parseJSON(params.row.fault_record);  // 故障信息
                            let parameters = util.parseJSON(params.row.j_params); // 故障时运行参数
                            return h('div', {
                                class: ['clickable-text'],
                                on: {
                                    click: () => {
                                        this.modal.device = {};
                                        this.modal.fault = record;
                                      this.modal.fault["gb_fault_no"] = params.row.gb_fault_no
                                        this.modal.params = parameters;
                                        this.modal.tabName = '1';
                                        this.modal.showFault = true;
                                        util.ajax.get('/device/getbyid', {
                                            params: {
                                                id: params.row.device_id
                                            }
                                        }).then(res => {
                                            let device = res.data || {};
                                            util.parseJSONResult(device);
                                            JsonFieldAdapter.fitJRegion(device);
                                            JsonFieldAdapter.fitJLocation(device);
                                            if (!res.code) this.modal.device = device;
                                            this.formatTabDevice(this.modal.device);
                                        })
                                    }
                                }
                            }, record?record.fault_name:"")
                        }
                    },
                    {
                        title: this.$t('l.fault_floor'),
                        align:'center',
                        key: 'fault_current_floor',
                        render: (h, params) => {
                            let parameters = util.parseJSON(params.row.j_params); // 故障时运行参数
                            return h('span', {
                            }, parameters?parameters.floor_current:"")
                        }
                    },
                    {
                        title: this.$t('l.occur_time'),
                        align: 'center',
                        key: 'occur_time',
                        render: (h, param) => {
                            return h('span', new Date(param.row.occur_time).pattern('yyyy-MM-dd HH:mm:ss'))
                        }
                    },
                    {
                        title: '处理时间',
                        align: 'center',
                        key: 'solve_time',
                        render: (h, param) => {
                            if (!param.row.solve_time) return  h('span','未处理故障');
                            return h('span', new Date(param.row.solve_time).pattern('yyyy-MM-dd HH:mm:ss'))
                        }
                    },
                ]
            }
        },
        methods: {
            loadData (page) {
                this.table.loading = true;
                let params = {
                    page: page || this.table.page.current,
                    size: this.table.page.size,
                    orderKey: this.table.page.sortKey,
                    orderMethod: this.table.page.sortMethod,
                    keyword: this.table.page.keyword,
                    solved: !!this.table.search.solved,
                    month: this.table.search.month.pattern('yyyyMM'),
                    language:localStorage.getItem('language')?localStorage.getItem('language'):'zh'
                };
                util.ajax.post('/fault/list',params).then((res) => {
                    this.table.loading = false;
                    this.setPage(res.data);
                });
            },
            setPage(pageInfo) {
                this.table.data = pageInfo.list
                this.table.page.current = pageInfo.pageNumber;
                this.table.page.total = pageInfo.totalRow;
            },
            preEdit (terminal, index) {
                this.modal.currentIndex = index;
                this.modal.terminal = util.deepCopy(terminal);
                this.modal.title = this.$t('l.terminal_info');
                if (!terminal.j_extra_capacity) {
                    terminal.j_extra_capacity = {
                        video_talking: {
                            enable: false
                        },
                        one_key_help: {
                            enable: false
                        },
                        face_recognition: {
                            enable: false
                        },
                        mobile_control: {
                            enable: false
                        },

                    }
                }
                this.modal.showFault = true;
            },
            show (index) {
                this.$Modal.info({
                    title: 'User Info',
                    content: `Name：${this.table.data[index].name}<br>Age：${this.table.data[index].age}<br>Address：${this.table.data[index].address}`
                })
            },
            remove (index) {
                this.table.data.splice(index, 1);
            },
            preAdd () {
                this.modal.community = {
                    name: '',
                    address: '',
                    j_buildings: [],
                    j_region: this.modal.j_region_temp
                }

                this.modal.title = this.$t('l.create_community');
                this.modal.showFault = true;
            },
            searchSolvedList () {
                if (!this.table.search.month) {
                    this.$Message.warning(this.$t('l.remark105'))
                    return;
                }
                this.loadData(this.table.page.current);
            },
            formatTabDevice (device) {
                if(device) delete device.j_buildings;
                util.parseJSONResult(device);
                let j_location = device.j_location;
                if (j_location){
                    device.location = (j_location.building?j_location.building.name:'') +
                        (j_location.unit?' - '+j_location.unit.name:'') +
                        (j_location.door?' - '+j_location.door.name:'');
                }
                let j_region =typeof device.j_region== 'string'?JSON.parse(device.j_region):device.j_region;
                if (j_region){
                    device.region = (j_region.province?j_region.province.name:'') + ' ' +
                        (j_region.city?j_region.city.name:'') + ' ' +
                        (j_region.area?j_region.area.name:'')+device.address?device.address:(device.caddress?device.caddress:"")
                }
            },
            searchBlur() {
                if (!this.table.page.keyword) this.loadData(this.table.page.current);
            },

        //   导出已解决故障记录
            exportFaultRecord(){
                this.$Modal.confirm({
                    title: this.$t('l.prompt'),
                    content: this.$t('l.remark232'),
                    onOk: () => {
                        axios({
                            responseType: "blob",
                            method: "post",
                            url: "https://api.diantiyun.com/fault/export",
                            data: {
                                sovedMonth:this.table.search.month.pattern('yyyyMM'),
                                language:(localStorage.getItem("language") ? localStorage.getItem("language"):'zh-CN')
                            },
                        }).then(response => {
                            //这里面是请求成功以后下载文件的方法
                            let a = document.createElement('a');
                            //ArrayBuffer 转为 Blob
                            let blob = new Blob([response.data], {type: "application/vnd.ms-excel;charset=utf-8"});
                            let objectUrl = URL.createObjectURL(blob);
                            a.setAttribute("href",objectUrl);
                            a.setAttribute("download", '电梯云故障记录导出数据.xls');
                            a.click();
                        });


                        //
                        // util.ajax.get("/fault/export",{
                        //     params:{
                        //         sovedMonth:this.table.search.month.pattern('yyyyMM'),
                        //         language:(localStorage.getItem("language") ? localStorage.getItem("language"):'zh-CN')
                        //     }
                        // })
                    },
                })
            },
        },
        created() {
            this.loadData(this.table.page.current);
            util.page_fault = this;
        },
    };

</script>

<style lang="less" scoped>
    .btn-context-menu {
        &>span {
            cursor: pointer;
            margin: 0 3px;
            &>i{
                transition: transform 0.3s;
            }
            &:hover>i{
                transform: rotateY(180deg);
            }
        }

    }
    .alarm_charger{
        display: grid;
        margin-left: 20px;
        font-size: 12px;
        color: #808695
    }

</style>
